import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { Seller } from 'src/app/core/sellers.service';
import { SELLERS_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { SellersStoresDialogComponent } from '../sellers-stores-dialog/sellers-stores-dialog.component';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { SellersSetPhoneDialogComponent } from '../sellers-set-phone-dialog/sellers-set-phone-dialog.component';
import { SellersEditDialogComponent } from '../sellers-edit-dialog/sellers-edit-dialog.component';
import { SellersSetMfaDialogComponent } from '../sellers-set-mfa-dialog/sellers-set-mfa-dialog.component';
import { SellersAccessControlDialogComponent } from '../sellers-access-control-dialog/sellers-access-control-dialog.component';
import { SellersConfirmOtpDialogComponent } from '../sellers-confirm-otp-dialog/sellers-confirm-otp-dialog.component';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-sellers-data-table',
  templateUrl: './sellers-data-table.component.html',
  styleUrls: ['./sellers-data-table.component.scss'],
})
export class SellersDataTableComponent {
  @Input() sellers: Seller[] = [];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = SELLERS_TABLE_COLUMNS;

  constructor(
    private dialog_service: DialogService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  onStoresClick(seller: Seller): void {
    this.dialog_service.openDialog(SellersStoresDialogComponent, { seller_id: seller.seller_id });
  }

  onSetPhoneClick(seller: Seller): void {
    this.dialog_service
      .openDialog(SellersSetPhoneDialogComponent, { seller })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  onEditClick(seller: Seller): void {
    this.dialog_service
      .openDialog(SellersEditDialogComponent, { seller })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onSetMfaClick(seller: Seller): void {
    this.dialog_service
      .openDialog(SellersSetMfaDialogComponent, { seller })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onUnlockSellerClick(seller: Seller) {
    this.dialog_service
      .openDialog(SellersAccessControlDialogComponent, {
        seller,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onConfirmSellerClick(seller: Seller) {
    this.dialog_service
      .openDialog(SellersConfirmOtpDialogComponent, {
        seller,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onInfoClick(seller: Seller): void {
    this.dialog_service.openDialog(SellersConfirmOtpDialogComponent, {
      seller,
    });
  }

  onDetailsClick(seller: Seller): void {
    this.navigation_service.toSellerDetails(seller.seller_id as string);
  }

  getFullName(seller: Seller): string {
    return `${seller.firstname} ${seller.lastname}`;
  }
}
